import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/forgot", { email });
      setSent(true);
      toast.success("Si tu correo está registrado, recibirás un enlace.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Algo salió mal. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--mep-black)] text-white mep-grain flex flex-col">
      <header className="px-5 md:px-10 py-5">
        <Link to="/login" data-testid="forgot-back-link" className="flex items-center gap-2 text-sm text-[var(--mep-text-muted)] hover:text-white">
          <ArrowLeft size={16} /> Volver a inicio de sesión
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="w-full max-w-md">
          <div className="mep-pill-gold mb-4">Recuperar acceso</div>
          <h1 className="font-display text-4xl md:text-5xl font-light tracking-tighter mb-2">
            ¿Olvidaste tu contraseña?
          </h1>
          <p className="text-[var(--mep-text-muted)] mb-8">
            Escribe tu correo y te enviaremos un enlace seguro para restablecerla.
          </p>

          {sent ? (
            <div
              data-testid="forgot-success-card"
              className="p-6 rounded-xl bg-[rgba(212,175,55,0.08)] border border-[var(--mep-gold)]/30 text-center"
            >
              <Mail size={32} className="text-[var(--mep-gold)] mx-auto mb-3" />
              <p className="text-sm text-[var(--mep-text)] leading-relaxed">
                Si <strong>{email}</strong> está registrado, recibirás un correo con el enlace para restablecer tu contraseña.
              </p>
              <p className="text-xs text-[var(--mep-text-muted)] mt-3">
                El enlace expira en 60 minutos. Revisa también tu carpeta de spam.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] mb-2 block">Correo</label>
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-[var(--mep-surface)] border border-[var(--mep-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--mep-pink)] transition"
                />
              </div>
              <button
                data-testid="forgot-submit-btn"
                type="submit"
                disabled={loading}
                className="btn-pink w-full py-4 font-semibold"
              >
                {loading ? "Enviando..." : "Enviar enlace de recuperación"}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
